export const getStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: 'cacl(100vh - 20px)',
        paddingBottom: '20px'
    },
    cardContainer: {
        padding: '20px 20px 0px 20px',
        marginLeft: '30px'
    },
    appContainer: {
        padding: '15px',
        bgcolor: '#FFFFFF',
        borderRadius: '10px',
        border: '2px solid #DEDEDE',
        width: { xs: '100%', sm: '280px' },
        boxSizing: 'border-box'
    }
})